<style lang="scss">
	.shipment-steps .ivu-steps-tail>i:after{
		top:-1px !important;
	}
	.comson{
        position: relative;
        z-index: 100000;
    }
    .comson .ivu-modal-mask,.comson .ivu-modal-wrap{
        z-index: 100000 !important
    }
</style>

<template>
	<div>
		<Breadcrumb class="tablelist-header" v-show="!querytype">
			<BreadcrumbItem>{{title[type]}}发运单</BreadcrumbItem>
		</Breadcrumb>
		<Alert v-if="type==='review'" class="padding-10" show-icon>操作提示：带有”
			<span class="color-danger">*</span>“的选项为必填项，其他为选填项。
		</Alert>
		<Steps :current="statusIndex" class="bg-fff padding-20 shipment-steps" v-if="type==='query'">
			<Step v-for="(val,key) of progressStatus" :title="val.name" :key="key"></Step>
		</Steps>
		<compBase
			v-if="(status==='base'||status==='review')&&!issuper"
			:data="baseData"
			:type="type"
			:status="status"
		></compBase>
		<compAddress
			v-if="(status==='address'||status==='review')&&!issuper"
			:data="addressData"
			:type="type"
			:status="status"
		></compAddress>
		<compBill
			v-if="status==='bill'||status==='review'"
			:data="billData"
			:type="type"
			:status="status"
		></compBill>
		<compLog v-if="type==='query'&&!issuper" :data="logData"></compLog>
		<footer class="bg-fff padding-20 text-right" v-if="status==='review'&&type!=='query'&&!issuper">
			<Button type="primary" class="width-15per" @click="submit(true)">保存</Button>
			<Button type="primary" class="width-15per" @click="submit(false)">保存并提交</Button>
			<Button type="primary" class="width-15per" @click="back">返回修改</Button>
			<Button type="primary" class="width-15per" @click="cancel">取消</Button>
		</footer>
		<Modal class="hidefooter" v-model="showSubmit" :mask-closable="false">
			<compSubmit
				status="1"
				:id="id"
				:shipType="baseData.shipType"
				v-if="showSubmit"
				@on-close="showSubmit=false"
				@on-update="cancel"
			/>
			<footer slot="footer" v-show="false"></footer>
		</Modal>
		<div v-if="querytype" class="text-right">
			<vButton @click="comclose">关闭</vButton>
		</div>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import compBase from './base'
import compBill from './bill'
import compAddress from './address'
import compLog from './log'
import compSubmit from '../operates/submit'
import { HttpShipBill, HttpSaveShipBillPlan, HttpSaveShipBillItems, HttpSaveShipBillAddress, HttpUpdateteShipBillAddress } from '@/service/boss/shipment'

export default {
	props:['activeids','querytype'],
	components: {
		compBase,
		compBill,
		compAddress,
		compSubmit,
		compLog
	},
	data() {
		return {
			showSubmit: false,
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			issuper: this.$route.query.issuper == 1,
			status: '',
			baseData: {},
			billData: {},
			addressData: [],
			logData: [],
			title: {
				add: '新增',
				edit: '编辑',
				query: '查看',
			},
			progressStatus: [
				{ value: 'draft', name: '草稿' },
				{ value: 'establish', name: '已创建' },
				{ value: 'submit', name: '已提交' },
				{ value: 'confirm', name: '已确认' },
				// { value: 'reject', name: '已驳回' },
				{ value: 'shipment', name: '已发运' },
				{ value: 'complete', name: '已完成' },
				// { value: 'close', name: '已取消' },
				// { value: 'delete', name: '已删除' },
			],
		}
	},
	created() {
		// console.log(this.activeids)
		// console.log(this.id)
		if(this.activeids){
			this.id = this.activeids
			this.type = this.querytype
		}else{
			this.id = this.id
			this.type = this.type
		}
		if (this.type === 'add') {
			this.status = "base";
		} else if (this.type === 'edit') {
			this.getDetail().then(() => {
				this.status = 'base'
			})
		} else if (this.type === 'bill') {
			this.getDetail().then(() => {
				this.status = 'bill'
			})
		} else if (this.type === 'query') {
			this.getDetail().then(() => {
				this.status = 'review'
			})
		} else {
			this.status = 'review'
		}
	},
	mounted() {
		
		if (this.type !== 'query') {
			window.addEventListener('beforeunload', this.beforeunload, false)
		}
	},
	computed: {
		statusIndex() {
			const status = this.baseData.orderStatus;
			return this.progressStatus.findIndex((item) => {
				return item.value === status
			})
		}
	},
	methods: {
		beforeunload(event) {
			event = event || window.event;
			event.returnValue = "系统可能不会保存您所做的更改!";
			return "系统可能不会保存您所做的更改!";
		},
		handleResponse(data = {}) {
			this.$set(this.$data, 'baseData', data.shipmentPlans || {});
			this.$set(this.$data, 'billData', data.shipmentPlanOrders || []);
			this.$set(this.$data, 'addressData', data.shipmentPlanOrderPicks || []);
			this.$set(this.$data, 'logData', data.StockOpLogEntityList || []);
			const orderStatus = data.shipmentPlans.orderStatus;
			if (orderStatus === 'reject') {
				this.progressStatus = [
					{ value: 'reject', name: '已驳回' },
					{ value: 'submit', name: '已提交' },
					{ value: 'confirm', name: '已确认' },
					{ value: 'complete', name: '已完成' },
				]
			} else if (orderStatus === 'close') {
				this.progressStatus = [
					{ value: 'close', name: '已取消' },
				]
			}

		},
		back() {
			this.getDetail().then(res => {
				this.status = 'base';
			})
		},
		cancel() {
			this.$router.push({
				name: "spBill"
			})
		},
		comclose(){
			this.$emit('on-close')
		},
		//加载详情
		async getDetail() {
			this.loading = true;
			return HttpShipBill({
				id: this.id
			}).then(res => {
				this.handleResponse(res.data);
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
			});
		},
		// 发运单修改目的仓地址-发运中
		async submitShipBillAddress() {
			this.loading = true;
			const formData = this.billData.map((item) => {
				const { id, parentId, orgWarehouseId, addressCode = "" } = item;
				return {
					id, parentId, orgWarehouseId, addressCode
				}
			})
			return HttpUpdateteShipBillAddress({ shipmentPlanOrders: formData }).then((res) => {
				this.loading = false;
				this.cancel();
			}, (err) => {
				this.loading = false;
				this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
			})
		},

		//头单据
		async submitHeadBill() {
			this.loading = true;
			return HttpSaveShipBillPlan(this.baseData).then((res) => {
				this.loading = false;
				this.baseData.id = this.id = res.data;
				this.status = "bill";
			}, (err) => {
				this.loading = false;
				this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
			})
		},
		//子单据
		async submitChildBill() {
			this.loading = true;
			this.billData.forEach(item => {
				item.parentId = this.id;
			});
			if (this.issuper) {
				return this.submitShipBillAddress();
			}
			return HttpSaveShipBillItems({ shipmentPlanOrders: this.billData }).then((res) => {
				this.addressData = res.data;
				this.status = "address";
				this.loading = false;
			}, (err) => {
				this.loading = false;
				this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
			})
		},
		async submit(bool) {
			this.loading = true;
			this.addressData.forEach(item => {
				item.parentId = this.id;
			});
			HttpSaveShipBillAddress({ shipmentPlanOrderPicks: this.addressData }).then((res) => {
				this.loading = false;
				if (bool) {
					this.cancel()
				} else {
					this.showSubmit = true;
				}
			}, (err) => {
				this.loading = false;
				this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
			})
		},
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this.beforeunload, false)
	}
}
</script>